/* eslint-disable no-restricted-syntax */
import { head, isArray, isEmpty, isObject, isString } from 'lodash';

import { ensureObject } from 'utils/objects';

const findDetailsWithArray = (error = {}) => {
  // @data.response.details being undefined
  if (isEmpty(error)) {
    return { message: null };
  }

  // @data.response.details being error array itself, so return message directly
  if (isArray(error)) {
    return { message: ensureObject(head(error)).message };
  }

  // @Check key value pairs on data.response.details, if object, check if it has an error-array value
  // If it does not have an error-array value, recurse it and repeat this until it finds the error-array.
  for (const [key, value] of Object.entries(error)) {
    if (isString(value)) {
      return { message: value };
    }

    if (isArray(value)) {
      const response = head(value);
      const message = isString(response) ? response : response?.message;
      return { message, key };
    }

    if (isObject(value)) {
      const found = findDetailsWithArray(value);
      if (found) {
        return found;
      }
    }
  }

  return { message: null };
};

const extractErrorMessageFromResponse = error => {
  // If error response is void, return
  if (isEmpty(error)) {
    return { message: null };
  }

  // If error response is string, return string itself
  if (isString(error)) {
    return { message: error };
  }

  // If error.response is string, return string itself
  if (isString(error.response)) {
    return { message: error?.response };
  }

  // If non of the extracted values below exists, pass error for cycle-through
  if (!error.response && !error.details && !error.message) {
    return findDetailsWithArray(error);
  }

  // get response && message from the error object
  const { message, response, details } = ensureObject(error);
  // extract error message with @findDetailsWithArray function
  const { message: errorMessage, key } = findDetailsWithArray(
    isEmpty(response) ? details : response,
  );

  return { message: errorMessage || message, key };
};

export default extractErrorMessageFromResponse;
